export const getIssueHeaderTitle = ({
  code,
  title,
}: {
  code?: string;
  title?: string;
}) => `#${code} ${title}`;
